export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-12.08df3cdc.jpg";